<div [ngStyle]="{'width': size+'px', 'height': size+'px'}" class="initiales_name satisfaction_{{satisfaction}} after-inline">
  <span>{{letters.toUpperCase()}}</span>
</div>
